a.s.chat = function () {
	var chobj = {};
	chobj.el = undefined;
	chobj.section = undefined;
	chobj.id = undefined;
	chobj.listData = {
		totalhits:0
	}
	chobj.ready = function(){}
	chobj.change = function(){}
	chobj.insert = function(){
		tpl.run({tpl:'/tpl/shared/chat/main.ejs?v='+v,data:{},cb:function(content){
			chobj.el.empty().append(content);
			setTimeout(function(){
				// Bindings
				$('button[data-action="add-comment"]',chobj.el).unbind('click').click(function(){
					chobj.postComment();
				});
				// Initial list load
				chobj.loadList(true,0,true);
			},50);
		}});
	}
	chobj.loadList = function(initial,offset,reset){
		$('>.chat>.loader',chobj.el).show();
		$.ajax({
			type:'GET',
			url:'/api/chat/list/',
			data:{
				section:chobj.section,
				id:chobj.id,
				limit:initial?3:10,
				offset:offset,
				token:localStorage.getItem('token'),
				accountname:localStorage.getItem('accountname')
			},
			dataType:'json',
			cache: false,
			success:function(result) {
				if (result.success && result.list) {
					chobj.listData.totalhits = result.totalhits;
					tpl.run({tpl:'/tpl/shared/chat/list.ejs?v='+v,data:result,cb:function(content){
						if (reset) {
							$('ul.commentlist',chobj.el).empty().append(content);
						}
						else {
							$('ul.commentlist',chobj.el).prepend(content);
						}
						if (result.pagination.has_next_page) {
							$('button[data-action="load-older-comments"]',chobj.el).show().unbind('click').click(function(){
								chobj.loadList(false,result.pagination.next_page,false);
							});
						}
						else {
							$('button[data-action="load-older-comments"]',chobj.el).unbind('click').hide();
						}
						// Bind record actions
						$('a[data-action="edit"]',chobj.el).unbind('click').click(function(){
							chobj.enableEdit($(this).attr('data-cid'));
						});
						$('a[data-action="delete"]',chobj.el).unbind('click').click(function(){
							if (confirm('Do you really want to delete this comment?')) {
								chobj.deleteComment($(this).attr('data-cid'));
							}
						});

						//chobj.el[0].scrollTop = chobj.el[0].scrollHeight;
					}});
				}
				else {
					tpl.run({tpl:'/tpl/shared/chat/empty.ejs?v='+v,data:result,cb:function(content){
						$('ul.commentlist',chobj.el).empty().append(content);
					}});
				}
				chobj.ready();
			}
		}).done(function(){
			$('>.chat>.loader',chobj.el).hide();
		});
	}
	chobj.postComment = function(){
		a.loader.fs.create();
		$.ajax({
			type:'POST',
			url:'/api/chat/create/',
			data:{
				section:chobj.section,
				sectionid:chobj.id,
				comment:$('textarea[name="comment"]',chobj.el).val(),
				token:localStorage.getItem('token'),
				accountname:localStorage.getItem('accountname')
			},
			dataType:'json',
			cache: false,
			success:function(result) {
				if (result.success) {
					$('textarea[name="comment"]',chobj.el).val('');
					a.s.growl.create('Success','Your comment was posted',{});
					chobj.loadList(true,0,true);
				}
				else {
					if (result.errorlist) {
						result.errorlist.forEach(function(e){
							a.s.growl.create('Error',e,{});
						});
					}
					else {
						a.s.growl.create('Error','Unable to post comment',{});
					}
				}
			}
		}).done(function(){
			a.loader.fs.remove();
		});
	}
	chobj.enableEdit = function(cid){
		var row = $('ul.commentlist>li[data-cid="'+cid+'"]',chobj.el);
		var comment = $('.comment>.edit>textarea',row).val();
		$('.comment>p,.comment>ul.options',row).hide();
		$('.comment>.edit',row).show();
		$('.comment>.edit>div>button[data-action="cancel"]',row).unbind('click').click(function(){
			$('.comment>.edit>textarea',row).val(comment);
			chobj.disableEdit(cid);
		});
		$('.comment>.edit>div>button[data-action="save"]',row).unbind('click').click(function(){
			a.loader.fs.create();
			$.ajax({
				type:'POST',
				url:'/api/chat/save/',
				data:{
					section:chobj.section,
					sectionid:chobj.id,
					cid:cid,
					comment:$('.comment>.edit>textarea',row).val(),
					token:localStorage.getItem('token'),
					accountname:localStorage.getItem('accountname')
				},
				dataType:'json',
				cache: false,
				success:function(result) {
					if (result.success) {
						a.s.growl.create('Success','The comment changes was saved',{});
						$('.comment>p',row).text($('.comment>.edit>textarea',row).val()).replaceAll("\n","<br>\n");
						chobj.disableEdit(cid);
					}
					else {
						a.s.growl.create('Error','Unable to save changes',{});
					}
				}
			}).done(function(){
				a.loader.fs.remove();
			});
		});
	}
	chobj.disableEdit = function(cid){
		var row = $('ul.commentlist>li[data-cid="'+cid+'"]',chobj.el);
		$('.comment>p,.comment>ul.options',row).show();
		$('.comment>.edit',row).hide();
	}
	chobj.deleteComment = function(cid){
		var row = $('ul.commentlist>li[data-cid="'+cid+'"]',chobj.el);
		var comment = $('.comment>p',row).html();
		$('.comment>p',row).html('<i>Removing comment...</i>');
		a.loader.fs.create();
		$.ajax({
			type:'POST',
			url:'/api/chat/delete/',
			data:{
				section:chobj.section,
				sectionid:chobj.id,
				cid:cid,
				token:localStorage.getItem('token'),
				accountname:localStorage.getItem('accountname')
			},
			dataType:'json',
			cache: false,
			success:function(result) {
				if (result.success) {
					a.s.growl.create('Success','The comment was remove',{});
					$('.comment>p',row).html('<i>Comment was removed '+moment(result.time_deleted).format('LLL')+'</i>');
					$('.comment>ul.options',row).remove();
				}
				else {
					a.s.growl.create('Error','Unable to remore comment',{});
					$('.comment>p',row).val(comment);
				}
			}
		}).done(function(){
			a.loader.fs.remove();
		});
	}
	chobj.getListData = function(){
		return chobj.listData;
	}
	return chobj;
}